import { render, staticRenderFns } from "./editUser.vue?vue&type=template&id=0b3f5327&scoped=true"
import script from "./editUser.vue?vue&type=script&lang=js"
export * from "./editUser.vue?vue&type=script&lang=js"
import style0 from "./editUser.vue?vue&type=style&index=0&id=0b3f5327&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f5327",
  null
  
)

export default component.exports